import { useState, useEffect } from 'react';
import { Grid, List } from '../../../svg';
import { Link } from 'react-router-dom';
import ModuloGrid from './modulo-grid';
import ModuloList from './modulo-list';
import { getModulos } from '../../../api/modulo';
import { useNavigate } from 'react-router-dom';
import { retrieveToken } from '../../../hooks/use-token';

const ModuloDetailsArea = ({ curso }) => {
  
  const [isOpen, setOpen] = useState(false);
  const [modulos, setModulos] = useState([]);
  
  const navigate = useNavigate();
  
  useEffect(() => {

      const tokenApi = retrieveToken();

      if (!tokenApi) {
        navigate("/entrar");
      } else {
        if (curso !== null && modulos.length == 0) {
          getModulos(tokenApi, Number(curso.cd_curso)).then(function(result) {
            setModulos(result);
          });
        }
      }
  }, [navigate, curso]);
  
  if (curso !== null)  {
    
    return (
      <>
      
      <section className="page__title-area pt-120 pb-90">
      {/* <div className="page__title-shape">
      <img className="page-title-shape-5 d-none d-sm-block" 
      src="/assets/img/page-title/page-title-shape-1.png" alt="" />
      <img className="page-title-shape-6" src="/assets/img/page-title/page-title-shape-6.png" alt="" />
      <img className="page-title-shape-7" src="/assets/img/page-title/page-title-shape-4.png" alt="" />
      </div> */}
      <div className="container">
      <div className="row">
      <div className="col-xxl-12 col-xl-12 col-lg-12">
      <div className="course__wrapper">
      <div className="page__title-content mb-25">
      <div className="page__title-breadcrumb">
      <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
      <li className="breadcrumb-item"><Link to="/">Principal</Link></li>
      <li className="breadcrumb-item active" aria-current="page">{curso.nome}</li>
      </ol>
      </nav>
      </div>
      {/* <span className="page__title-pre">{course.category}</span> */}
      <h5 className="page__title-3" style={{ marginBottom: '50px' }}>Módulos -  {curso.nome}</h5>
      </div>
      
      </div>
      </div>
      
      <section className="course__area pt-50 pb-120">
      <div className="container">
      {/* <div className="course__tab-inner grey-bg-2 mb-50">
      <div className="row align-items-center">
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <div className="course__tab-wrapper d-flex align-items-center">
      <div className="course__tab-btn">
      <ul className="nav nav-tabs" id="courseTab" role="tablist">
      <li className="nav-item" role="presentation">
      <button className={`nav-link ${!modulos && 'active'}`} id="grid-tab" data-bs-toggle="tab" data-bs-target="#grid" type="button" role="tab" aria-controls="grid" aria-selected="true">
      <Grid />
      </button>
      </li>
      <li className="nav-item" role="presentation">
      <button className={`nav-link list ${modulos && 'active'}`} id="list-tab" data-bs-toggle="tab" data-bs-target="#list" type="button" role="tab" aria-controls="list" aria-selected="false">
      <List />
      </button>
      </li>
      </ul>
      </div>
      
      </div>
      </div>
      
      </div>
      </div> */}
      <div className="row">
      <div className="col-xxl-12">
      <div className="course__tab-conent">
      <div className="tab-content" id="courseTabContent">
      <div className={`tab-pane fade ${!modulos && 'show active'}`} id="grid" role="tabpanel" aria-labelledby="grid-tab">
      <div className="row">
      <ModuloGrid itemsPerPage={50} items={modulos} />
      </div>
      </div>
      
      <div className={`tab-pane fade ${modulos && 'show active'}`} id="list" role="tabpanel" aria-labelledby="list-tab">
      <div className="row">
      <ModuloList itemsPerPage={50} items={modulos} />
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      
      </div>
      </section>
      
      </div>
      </div>
      </section>
      </>
      );
    }
  };
  
  export default ModuloDetailsArea;